export default "__VITE_ASSET__DyRwYePb__"